import { type LineCustomSvgLayer } from '@nivo/line'
import { sumBy } from 'lodash'
import { type LineChartSeries } from 'ComponentLibrary/src/molecules/Chart/types'
import { type WithBars } from './types'

export const IncomeChartBarLayer: LineCustomSvgLayer<LineChartSeries> = ({ points, yScale, innerHeight }) => {
    return (
        <>
            {points.map((point) => {
                const bars = point.data.bars as WithBars<object>['bars']

                return bars
                    .map(
                        ({ id, color, value }, index) =>
                            value && (
                                <rect
                                    key={`${id}-${index}`}
                                    x={point.x - 4}
                                    y={yScale(sumBy(bars.slice(0, index + 1), 'value'))}
                                    height={innerHeight - (yScale(sumBy(bars.slice(0, index + 1), 'value')) || 0)}
                                    width={8}
                                    fill={color}
                                />
                            )
                    )
                    .toReversed() // Reverse since we want the smaller (not-stacked) bars in front
            })}
        </>
    )
}
